import { Accept } from 'react-dropzone/.'

import { FILE_FORMATS } from '../constants/file'

type FileTypes = keyof typeof FILE_FORMATS
interface Options {
  types: FileTypes[]
  /**
   * If you don't specify subtypes, it will include all subtypes
   */
  subTypes?: {
    [subType in FileTypes]?: (keyof (typeof FILE_FORMATS)[subType])[]
  }
}

export const getMimeTypeExtensionMap = ({
  types,
  subTypes,
}: Options): Accept => {
  return types.reduce<Accept>((accept, type) => {
    const includedSubtypes = subTypes?.[type] || Object.keys(FILE_FORMATS[type])

    Object.entries(FILE_FORMATS[type])
      .filter(([subType]) => includedSubtypes.includes(subType))
      .forEach(([_, { mimeType, extensions }]) => {
        accept[mimeType] = extensions
      })

    return accept
  }, {})
}

export const getMimeTypes = (options: Options) => {
  const mimeTypeExtensionMap = getMimeTypeExtensionMap(options)

  return Object.keys(mimeTypeExtensionMap)
}
